import { useNavigate } from "react-router-dom";

export interface CardViewProps {
  idx: string;
  title: string;
  thumbnail: string;
  sub_content: string;
  news_date: string;
  version: string;
  stat_int: number;
}

export interface CardViewListProps {
  response: CardViewProps;
}

const CardView = ({ response }: CardViewListProps) => {
  const navigate = useNavigate();

  const apiServer = process.env.NODE_ENV == "production" ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;
  const didShowNewsDetail = () => {
    navigate(`/news/${response.idx}`);
  };

  return (
    <div
      onClick={didShowNewsDetail}
      className="card-view-container flex-shrink-0 w-full desktop:w-[300px] bg-gray-50 rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300 ease-in-out overflow-hidden cursor-pointer mt-3 mb-3"
    >

    {response.thumbnail.includes('https') ? (
      <img src={response.thumbnail} className="w-full h-48 object-fill" />
    ) : response.thumbnail === "" ? (
      <img src="/assets/images/default_logo.png" className="w-full h-48 object-fill" />
    ) : response.thumbnail.includes("./img") ? (
      <img
        className="w-full h-48 object-fill"
        src={apiServer + response.thumbnail.replace(".", "")}
      />
    ) : (
      <img
        className="w-full h-48 object-fill"
        src={apiServer + response.thumbnail}
      />
    )}


      <div className="card-view-title-container p-2 flex flex-col">
        <div className="flex flex-col justify-start items-start">
          <div className="flex items-start spacex-4 h-auto font-sans">
            <span className="card-view-info-top w-full">
              <span className="card-view-info-description-box w-full text-center text-xs text-black bg-gray-200 p-1 rounded-md">
                보도자료
              </span>
              <span className="card-view-info-createdAt w-auto text-right text-xs font-normal text-gray-500 pl-3">
                {response.news_date}
              </span>
            </span>
          </div>
          <strong className="card-view-info-bottom w-full mt-2 text-base text-start">
            {" "}
            {response.title}
          </strong>
          <p className="card-view-info-description w-full text-left text-xs font-normal text-gray-500 whitespace-normal break-words line-clamp-2">
            {response.sub_content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CardView;
